export const dictEnStep2 = {
  DetailAddressHeader: 'Specify your address',
  DetailContactsHeader: 'Add contact details',
  ShipperAddress: 'Shipper’s address',
  ReceiverAddress: 'Receiver’s address',
  SenderContacts: 'Shipper',
  ReceiverContacts: 'Receiver',
  ReceiverContactsYou: 'Receiver (you)',
  Address: 'Address',
  Name: 'Full name',
  CompanyName: 'Company name (optional)',
  INN: 'TIN',
  LegalTitle: 'Bill To is a legal entity',
  LegalName: 'Bill To company full name',
  LegalNameTooltip:
    'Please state the company name in Russian as well as the form of business entity, e.g. ООО Планета, ПАО Фотострана, ИП Никитюк Л.Ю. etc.',
  LegalInn: 'Taxpayer TIN number',
  Phone: 'Phone number',
  Worktime: 'Worktime',
  Email: 'Email',
  ResidentRF: "Non-resident of the Russian Federation",
  DeliveryType: 'What would you like to send?',
  DeliveryTypeText: 'Please specify in detail what exactly you are sending.',
  DeliveryTypeTextAbroad: 'Please specify in detail what exactly you are sending in English (max 65 characters).',
  CourierNote: 'A note for the courier',
  DeliveryTypeHeader: 'Type of delivery',
  CourierOrder: 'Online booking for courier pickup',
  WalkOrder: 'Shipping from the DHL Service Point',
  ChooseServicePoint: 'Please select a DHL Express Service Point',
  SingleServicePoint: 'The DHL Express Service Point',
  Documents: 'Documents',
  NonDocuments: 'Shipments',
  InternationalWarnTitle: 'International non-document shipping',
  InternationalWarnJurik:
    'The shipment with customs value higher than 1000 EUR can\'t be created online. DHL can prodive you payable сustoms services. Please contact DHL Customer Service team by phone +7 (495) 961-10-67 to receive the detailed information.',
  InternationalWarnNonJurik:
    'The shipment with customs value higher than 1000 EUR can\'t be created online. DHL can prodive you payable сustoms services. DHL can prodive you payable сustoms services. Please contact DHL Customer Service team by phone +7 (495) 961-10-67 to receive the detailed information.',
  BookCourier: 'Book a courier pickup',
  CreateAnAwb: 'Create an AWB',
  declaredTitle: 'Declared Value',
  RecalculationDeclared: 'Recalculation of the shipment value in EUR will be made on the day of customs document registration. If the shipment value exceeds 1000 EUR, invoices for brokerage services can be issued in the country of origin.',
  ExtrasTitle: 'Optional services',
  PaymentsTitle: 'Choose the payment option',
  CashPaymentTitle: 'Pay by cash',
  CashPaymentOffice: 'Cash payment in the office',
  CashPaymentCourier: 'Cash payment to a courier',
  CardPaymentTitle: 'Pay by card',
  CardPaymentDescription: 'Pay by card in the office',
  OnlineCardPaymentTitle: 'Pay by card online',
  OnlineCardPaymentDescription: 'Pay online on the website',
  AcceptText: 'I accept',
  Conditions: 'DHL Express terms and conditions of carriage',
  ConditionsDiscount: 'Promo campaign terms and conditions',
  And: ' and',
  ProcessingPersonalData: 'processing of my personal data by DHL Express',
  ShippingCost: 'Shipping cost',
  DeliveryBy: 'Estimated date of delivery by',
  Delivery: 'Delivery by',
  Deliver: 'Deliver',
  Slower: 'slower',
  Faster: 'faster',
  PriceLessThenMinPrice: 'Insurance is provided only at a cost above {minPrice} rubles',
  PriceMoreThenMaxPrice: 'Insurance is provided only at a cost below {maxPrice} rubles',
  DeclaredValue: 'Declared Value',
  DeclaredValueDesc: 'Please, note that Declared Value must be equal Cost in Invoice.',
  Currency: 'Currency',
  FreeExtraCharge: 'Free of charge',
  From: 'From',
  To: 'To',
  PackageDetailTitle: 'Attention! Check your shipping details',
  PackageDetailReminderDimensions:
    'Please make sure that you provided correct shipment details (dimensions and weight). You can change the details',
  Here: 'here',
  PackageDetailSend: 'You are sending',
  PackageDetailContacts: 'Contact details',
  PackageDetailDeliveryTime: 'Delivery time by',
  PackageDetailDateOfShipmentServicePoint: 'Date of shipment processing in DHL Express Service Point',
  PackageDetailDateOfShipmentCourier: 'The date and time of a courier’s arrival to pick up the shipment',
  PackageDetailIncludingServices: 'including optional services',
  ReminderApproximateTime:
    'The indicated date and time of courier pickup are approximate. The exact date and time for the pick-up will be aligned with the shipper by DHL’s employee.',
  ReminderOnlinePay1: 'An amount will be pre-authorized on your card until the funds are debited:',
  Rubles: 'rubles',
  ReminderOnlinePay2: 'It includes the delivery cost',
  Plus: '+',
  ReminderOnlinePayReserve: 'rubles as reservation buffer.',
  ReminderOnlinePay3:
    'Your card will be charged the amount calculated by the courier, based on the dimensions and weight of your shipment within the pre-authorized sum in the day of pick up.',
  ReminderOnlinePay4: 'Any extra pre-authorized amounts will be released at the same time.',
  ReminderOnlinePay5:
    'If the booking is cancelled -  DHL will release your pre-authorized amount within 1 working day.',
  ReminderPrinter:
    'Please make sure that the sender (if you are not the sender) has a printer and can provide the printed copy of an airwaybill.',
  ReminderPrinterAbroad:
    'Important! Make sure that the shipper has a printer to print the airwaybill. It has to be printed out before the pick-up and handed over to the courier along with the documents.',
  ReminderPrinterCargoForeign:
    'Make sure that the sender of the shipment (if you are not one) has a printer for printing documents.',
  ReminderTotalPrice0:
    'The final delivery cost will be calculated after the shipment is weighed and measured by automatic systems. DHL charges the cost as follows:',
  ReminderTotalPrice1:
    '1) If the pre-authorized amount is sufficient, DHL charges the final cost. The timeframe for releasing the blocked amount depends on your bank.',
  ReminderTotalPrice2:
    '2) If the pre-authorized amount is not sufficient, DHL charges the whole blocked amount and additional remaining sum by a recurring payment.',
  ReminderTotalPrice3:
    'The airwaybill will be created once you have provided your card data. It will be sent to you and the shipper by email.',
  ReminderTotalPrice4: 'A fiscal receipt will be generated after the funds have been debited and sent to you by email.',
  AwbAndBillWillSendViaEmail:
    'The shipping airwaybill will be generated and forwarded to your email address after providing your bank card details. The receipt will be generated and forwarded to your email address as soon as your bank card is charged.',
  AwbWillSendViaEmail:
    'The shipping airwaybill will be forwarded to the email address you have provided over the previous steps.',
  AwbWillSendViaEmailCargoForeign: 'The documents will be generated and sent to the email address you have provided.',
  RemindSenderToPrintCourier:
    'The sender should print out the shipping airwaybill and hand it over to DHL courier along with the shipment.',
  RemindSenderToPrintCourierCargoForeign:
    'The sender must print out the documents before the courier arrives and give them to the courier along with the shipment.',
  PackageDetailAgreement: 'I confirm that I am the card owner and accept',
  PackageDetailAgreementLink: 'the Terms and Conditions of online card payment.',
  RemindSenderToPrintServicePoint:
    'The sender should print out the shipping airwaybill and provide it together with the shipment to DHL service point advisor.',
  RemindSenderToPrintServicePointCargoForeign:
    'The sender must print out the documents and send them to the service point advisor.',
  PayAttention:
    'Please be aware that in accordance with DHL aviation safety and security requirements we physically inspect all shipments and observe valid internal Russian passport or international passport for foreign citizens.',
  ReminderOnlinePayTooltip:
    'Reserve is required to avoid delays if sender provides incorrect weight/dimensions. Reserve shall be calculated as follows: 1000 RUB if the delivery cost (shipping cost/ rate quotation) is lower than 3000 RUB. 30% of the delivery cost if the delivery cost is more than 3000 RUB.',
  PrintLabels: 'Print labels',
  ConfirmAndPrint: 'Confirm booking and print airwaybill',
  WelcomeText: 'We are glad that you\'ve decided to ship your parcel with us',
  DownloadAwb: 'Download the airwaybill',
  DownloadInvoice: 'Download the invoice',
  AttentionMiles:
    'Please note, that the shipper should print the airwaybill. Sending shipment without printed airwaybill is impossible!',
  AttentionMilesCargoForeign:
    'Please note that the sender of the shipment must print out the documents (they contain the invoice and customs clearance documents). It is impossible to send shipment without printed documents!',
  ClickPrint: 'Please, wait for the courier.',
  ClickPrintCargoForeign: 'Please print out your documents and wait for the courier to arrive.',
  WalkPrint: 'Please, provide the service point advisor with your booking number.',
  SuccessShipmentServiceDeskInfo: 'Now you can come to the selected office {link} and send your shipment.',
  SuccessShipmentServiceDeskTell: 'To send your shipment, tell the service point advisor your booking number – ',
  OrderNumber: 'Your booking number',
  InPeriod: 'In period',
  TimeFrom: 'from',
  TimeTill: 'till',
  Time: 'Time',
  ApproximateTime: 'Estimated time',
  Attention: 'Attention!',
  PriceDifference: 'A Tariff that obtained during first calculation disagrees with current value.',
  TransitDifference: 'A Transit time that obtained during first calculation disagrees with current value.',
  PriceAndTransitDifference: 'A Price and a Transit time that obtained during first calculation disagrees with current value.',
  OnlinePaymentEmail:
    'Receipt (and the notification if the pickup is cancelled) will be forwarded to this email address.',
  ErrorOnlinePaymentWithPrinter:
    'The services "I/sender don\'t have a printer to print the invoice" and "Pay online" are not compatible. When you select "Pay online", the "no printer" option is removed.',
  timeRange: 'no available option | from {from} to {to}',
  ServicePointHint: 'Please choose a DHL service point to send the shipment from',
  ChooseDepartment: 'select and continue',
  Backward: 'Backward',
  Open: 'Open',
  Closed: 'Closed',
  Weekend: 'Weekend',
  SelectPointDelivery: 'Choose a service point convenient for you',
  SelectDepartment: 'Select department',
  SelectDepartmentOther: 'Select other department',
  NowLunch: 'closed for lunch',
  Lunch: 'Lunch',
  NewValue: 'New value',
  OldValue: 'Old value',
  ConfirmModalYes: 'Yes',
  ConfirmModalNo: 'No',
  ConfirmModalTitleChangeAddress: 'Changing user input',
  ConfirmModalChangeAddress: "To change the previous address to the Service Point address?",
  ConfirmModalPostalCod: "To change the previous zip code to the Service Point zip code?",
  DescriptionTooltipLocalCargo:
    'Sending shipments within Russia <br> to send medicines within Russia, you need to issue accompanying documents. For more information, please call +7&nbsp;(495)&nbsp;961-10-67',
  DescriptionTooltipNotLocalCargo:
    'Sending certain shipments may require providing additional documents or approval. For more information, please call {tellCity}',
  InvoiceBlockTitle: 'Information about the shipment',
  InvoiceBlockSubTitle: 'Describe separately each item of your shipment in Russian and English languages',
  InvoiceSelectPlaceholder: 'The purpose of the export',
  InvoiceListAddBtn: 'Add another item',
  InvoiceDescriptionRu: 'Item Description in Russian',
  InvoiceDescriptionEn: 'Item Description in English',
  InvoiceCommodityCode: 'HS Code',
  InvoiceCommodityCodeTip: 'Please note that the correct indication of the HS code is a prerequisite for the successful passage of customs clearance of your cargo',
  InvoiceQuantity: 'Quantity',
  InvoiceQuantityUnit: 'Units',
  InvoiceValue: 'Item Value',
  InvoiceCurrency: 'Code currency',
  InvoiceWeight: 'Net Weight, kg',
  InvoiceGrossWeight: 'Gross Weight, kg',
  InvoiceManufactureCountryCode: 'Origin of the goods',
  InvoiceBtnSave: 'Save',
  InvoiceBtnCancel: 'Cancel',
  InvoiceBtnEdit: 'Edit',
  InvoiceBtnDelete: 'Delete',
  InvoiceBtnRecover: 'Recover',
  InvoiceBtnCopy: 'Copy',
  InvoiceTotalItem: 'Total number of items',
  InvoiceTotalPrice: 'Total invoice price',
  InvoiceTotalWeight: 'Total weight',
  InvoiceTotalGrossWeight: 'Total gross weight',
  InvoiceTooltip: `International shipping requires creating an invoice. If you already have one, don't forget to hand it over to the courier along with the shipment.
  If you don't have an invoice, you can create it on our website right now. Certain shipments may require providing additional documents or approvals.
  Private individuals should also provide passport copy: first pages and registration page. For more information, please call: {tellCity}.`,
  DeadLineForWeekend:
    'The next available business day is selected as the shipping date. However, it is possible to send the shipment on a day off. Change the shipping date if necessary.',
  MessageNotAvailablePickUpTimeOne: 'First, select the DHL Service Point to determine the available time slots.',
  MessageNotAvailablePickUpTimeTwo:
    'Select the available time interval. If there are no time slots, select another Service Point',
  RemindSenderNotCompanyClickCargoNoLocal:
    '<p>To send a shipment abroad, the sender should hand over to the courier the following documents along with the shipment:</p><ul> <li>DHL airwaybill</li><li>invoice</li><li>copy of the the first pages of the passport and the page with registration</li><li>other accompanying documents (if necessary)</li></ul> <p>Please note that in the country of destination, customs taxes and brokerage services are possible, and are paid by the receiver. For more information, the receiver can contact the local DHL office in the country of destination.</p>',
  RemindSenderCompanyClickCargoNoLocal:
    '<p>To send a shipment, the sender should hand over to the courier the following documents along with the shipment:</p><ul> <li>DHL airwaybill</li><li>invoice with company stamp</li><li>other accompanying documents (if necessary)</li></ul> <p>Please note that in the country of destination, customs taxes and brokerage services are possible, and are paid by the receiver. For more information, the receiver can contact the local DHL office in the country of destination.</p>',
  RemindSenderNotCompanyWalkCargoNoLocal:
    '<p>The tariff is valid when shipped from a DHL service point.</p><p>The following documents are required for shipping:</p><ul> <li>DHL waybill</li><li>invoice</li ><li>copy of the front page of the passport and registration page (can be done at the DHL service point) </li><li>other accompanying documents (if necessary)</li></ul> <p>Please provide the booking number to a service point advisor and they will print out the airwaybill and invoice for you. Providing passport is necessary.</p><p>Please note that in the country of destination, customs taxes and brokerage services are possible, and are paid by the receiver. For more information, the receiver can contact the local DHL office in the country of destination.</p>',
  RemindSenderCompanyWalkCargoNoLocal:
    '<p>The tariff is valid when shipped from a DHL service point.</p><p>The following documents are required for shipping:</p><ul> <li>DHL waybill</li><li>invoice with the company stamp</li ><li>other accompanying documents (if necessary)</li></ul> <p>Please provide the booking number to a service point advisor and they will print out the airwaybill and invoice for you. Providing passport or driving license is necessary.</p><p>Please note that in the country of destination, customs taxes and brokerage services are possible, and are paid by the receiver. For more information, the receiver can contact the local DHL office in the country of destination.</p>',
  EmptyEmailMessage:
    "You did not enter the sender's email address to which we can send the airwaybill. If you don't know this email, just click next.",
  ExtrasTitleMore: '',
  BrokerageServices: 'Brokerage services in the country of departure are possible, and are paid by the sender.',
  ServiceNotVailablOnline: 'Service not available when paying online',
  MutualSettlementMessage: 'Dear customer! The cost of cash payments between legal entities exceeds the {cashLimitForCompanies} rubles. Please contact the call center for more details.',
};

export default {
  dictEnStep2,
};
